import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountSettingsModalComponent } from './pages/account-settings-modal/account-settings-modal.component';
import {WidgetLibraryModule} from '../_widget-library/widget-library.module';



@NgModule({
    declarations: [
        AccountSettingsModalComponent
    ],
    exports: [
        AccountSettingsModalComponent
    ],
    imports: [
        CommonModule,
        WidgetLibraryModule
    ]
})
export class AccountSettingsModule { }
